import React, { Component } from 'react';
import './scheme.css';
import { pickerState } from './ColorTool';

export class SchemeContainer extends Component {
    
    render() {
        return (
            <div>
                <div
                    className="scheme-container"
                    id={this.props.ordinal}
                    onClick={this.props.function}
                    style={{ backgroundColor: "white" }}
                >
                    <p className="scheme-container-title">{this.props.ordinal}</p>
                    <div id={this.props.ordinal_s + "-color"} className="scheme-container-content">
                        <p id={this.props.ordinal_s + "-hex"} className="scheme-container-content-hex"></p>
                        <span id={this.props.ordinal_s + "-font-color"} className="scheme-container-content-font-color">{this.props.ordinal_s}</span>
                    </div>
                    <div className="scheme-container-subcontent">
                        <div id={this.props.ordinal_s + "-light-color"} className="scheme-container-subcontent-small">
                            <p className="scheme-container-subcontent-title">{this.props.ordinal_s} — Light</p>
                            <p id={this.props.ordinal_s + "-light-hex"} className="scheme-container-subcontent-hex"></p>
                        </div>
                        <div id={this.props.ordinal_s + "-dark-color"} className="scheme-container-subcontent-small">
                            <p className="scheme-container-subcontent-title">{this.props.ordinal_s} — Dark</p>
                            <p id={this.props.ordinal_s + "-dark-hex"} className="scheme-container-subcontent-hex"></p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

